import HttpClient from '../utils/http-client';

export const RADIAN_EVENTS: Record<string, { code: string; name: string; description: string; color: string }> = {
  '030': {
    code: '030',
    name: 'Acuse de Recibo',
    description: 'Confirma que recibiste la factura del proveedor.',
    color: '#3b82f6',
  },
  '031': {
    code: '031',
    name: 'Rechazo de Factura',
    description: 'Rechazas la factura e informas el motivo a la DIAN.',
    color: '#ef4444',
  },
  '032': {
    code: '032',
    name: 'Recibo del Bien o Servicio',
    description: 'Confirma que recibiste el bien o servicio facturado.',
    color: '#8b5cf6',
  },
  '033': {
    code: '033',
    name: 'Aceptación Expresa',
    description: 'Aceptas la factura y manifiestas voluntad de pago.',
    color: '#10b981',
  },
  '034': {
    code: '034',
    name: 'Rechazo de Evento',
    description: 'Rechaza un evento previamente emitido.',
    color: '#ef4444',
  },
};

export interface RadianEventFilterParams {
  status?: string;
  event_code?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
}

export async function getRadianEvents(
  page = 1,
  limit = 20,
  filters: RadianEventFilterParams = {}
) {
  const httpClient = new HttpClient('', '');
  const params: Record<string, string | number> = {
    page,
    limit,
  };

  if (filters.status) params.status = filters.status;
  if (filters.event_code) params.event_code = filters.event_code;
  if (filters.date_from) params.date_from = filters.date_from;
  if (filters.date_to) params.date_to = filters.date_to;
  if (filters.search) params.search = filters.search;

  try {
    const response: any = await httpClient.get('/sells/events', params).toPromise();
    console.log('[RADIAN] getRadianEvents raw response:', response);

    // Envelope handling: response might be { success: true, data: { data: [], total: ... } } or directly { data: [], total: ... }
    const payload = response?.data !== undefined ? response.data : response;
    const events = payload?.data || payload?.events || (Array.isArray(payload) ? payload : []);
    const total = payload?.total !== undefined ? payload.total : events.length;

    return {
      data: events,
      total,
      page: payload?.page || page,
      page_size: payload?.page_size || payload?.limit || limit,
    };
  } catch (error) {
    console.error('[RADIAN] Error in getRadianEvents:', error);
    return { data: [], total: 0, page, limit };
  }
}

export async function getRadianEventDetail(eventId: number | string) {
  const httpClient = new HttpClient('', '');
  const response: any = await httpClient.get(`/sells/events/${eventId}`).toPromise();
  const payload = response?.data !== undefined ? response.data : response;
  return payload;
}

export async function getRadianEventsByCufe(cufe: string) {
  const httpClient = new HttpClient('', '');
  const response: any = await httpClient.get(`/sells/events/cufe/${cufe}`).toPromise();
  const payload = response?.data !== undefined ? response.data : response;
  return Array.isArray(payload) ? payload : (payload?.data || []);
}

export async function sendRadianEvent(
  eventCode: string,
  cufe: string,
  invoiceNumber: string,
  supplierNit: string,
  supplierName: string,
  supplierEmail?: string,
  typeRejectionId?: number
) {
  const httpClient = new HttpClient('', '');

  const payload: Record<string, unknown> = {
    document_reference: {
      number: invoiceNumber,
      uuid: cufe,
      type_document_id: 1,
    },
    receiver: {
      identification_number: supplierNit,
      name: supplierName,
      ...(supplierEmail ? { email: supplierEmail } : {}),
      type_document_identification_id: 6,
    },
  };

  if ((eventCode === '031' || eventCode === '034') && typeRejectionId !== undefined) {
    payload.type_rejection_id = typeRejectionId;
  }

  const response = (await httpClient
    .post(`/sells/events/${eventCode}`, payload)
    .toPromise()) as { data?: unknown } | undefined;

  return response?.data;
}
